import React, { useContext, useEffect, useState } from 'react';
import api from '../../../../../Utils/Api';
import { CurrentUserContext } from '../../../../../Contexts/CurrentUserContext';

import { NavLink, Link } from 'react-router-dom';
import './CourseCard.css';

const CourseCard = ({
    course,
    title,
    image,
    progress,
    average,
    totalTests,
    link,
    material,
    percent,
}) => {
    const { token } = useContext(CurrentUserContext);
    const [courseProgress, setCourseProgress] = useState([]);

    useEffect(() => {
        if (course && course.id) {
            api.getProgressCourse(token, course.id)
                .then((res) => {
                    console.log(res);
                    setCourseProgress(res);
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [course]);

    if (average > 100) {
        average = 100;
    }

    if (progress > totalTests) {
        progress = totalTests;
    }

    // console.log(average);

    return (
        <Link to={link}>
            <div className='courseCard__container'>
                <div className='courseCard__infoContainer'>
                    <div className='courseCard__title'>{title}</div>
                    <div
                        className='courseCard__infoBlock_wrap'
                        style={{ bottom: title.length > 30 ? '13vh' : '15vh' }}
                    >
                        <div className='courseCard__infoBlock'>
                            <div className='courseCard__info'>Пройдено тестов:</div>
                            <div className='courseCard__infoDigit'>{`${progress}/${totalTests}`}</div>
                        </div>
                        <div className='courseCard__infoBlock'>
                            <div className='courseCard__info'>Средний результат:</div>
                            <div className='courseCard__infoDigit'>
                                {average.includes('%') ? average : `${average}%`}
                            </div>
                        </div>
                    </div>
                    {courseProgress && courseProgress.topics_count !== undefined && (
                        <div className='courseCard__infoMaterial'>
                            <div className='courseCard__infoMaterialOne'>
                                {courseProgress.topics_count === 1
                                    ? `${courseProgress.topics_count} тема`
                                    : courseProgress.topics_count < 5
                                    ? `${courseProgress.topics_count} темы`
                                    : `${courseProgress.topics_count} тем`}{' '}
                            </div>
                            {courseProgress.lessons_count && (
                                <div>
                                    {courseProgress.lessons_count == 1
                                        ? `${courseProgress.lessons_count} урок`
                                        : `${courseProgress.lessons_count} уроков`}
                                </div>
                            )}
                        </div>
                    )}
                    {(courseProgress.progress_in_course !== null ||
                        (percent !== null && percent !== undefined)) && (
                        <div className='courseCard__percent_wrap'>
                            <div
                                className={`courseCard__percent ${
                                    percent < 1
                                        ? 'courseCard__percent_empty'
                                        : 'courseCard__percent_full'
                                }`}
                            >
                                <div
                                    className='courseCard__percent_fill'
                                    style={{
                                        width: `${courseProgress.progress_in_course || 0}%`,
                                    }}
                                ></div>
                            </div>
                            <div>
                                Пройдено:
                                <span>
                                    {courseProgress.progress_in_course >= 0
                                        ? courseProgress.progress_in_course
                                        : percent}
                                    %
                                </span>
                            </div>
                        </div>
                    )}
                    {/* <div className={`themeRoadMap__percent ${percent < 1 ? 'themeRoadMap__percent_empty' : 'themeRoadMap__percent_full'}`}>{percent}%
                    {percent > 0 && <svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="70" height="70" xmlns="http://www.w3.org/2000/svg">
                        <circle className="circle-chart__circle" stroke="#7A5AF8" strokeWidth="2" strokeDasharray={`${percent},100`} strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                    </svg>}
                    
                </div> */}
                </div>
                {image ? (
                    <img className='courseCard__image' src={image} alt='cover' />
                ) : (
                    <div className='courseCard__image' />
                )}
            </div>
        </Link>
    );
};
export default CourseCard;
